import { FC, useEffect, useState } from 'react';
import { MenuProps } from 'antd';

import { getNavRef } from 'features/navigation/lib/getNavRef';
import { MenuStyled } from './ApplicationMenu.styles';

import './ApplicationMenu.css';

type ApplicationNavItem = {
	name: string;
	key: string;
	included: boolean;
};

interface ApplicationMenuProps {
	navItems: ApplicationNavItem[];
	refHandlers: { key: string; handler: () => void; onScreen: boolean }[];
}

export const ApplicationMenu: FC<ApplicationMenuProps> = ({ navItems, refHandlers }) => {
	const [isPinned, setIsPinned] = useState(false);
	useEffect(() => {
		const nav = document.querySelector(`.nav`);
		const observer = new IntersectionObserver(
			([e]) => {
				setIsPinned(e.intersectionRatio < 1);
			},
			{ threshold: [1] },
		);

		if (nav) {
			observer.observe(nav);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	const items: MenuProps['items'] = navItems
		.filter(n => n.included)
		.map(n => ({
			label: n.name,
			key: n.key,
		}));

	const handleClick: MenuProps['onClick'] = e => {
		getNavRef(e.key, refHandlers);
	};

	return (
		<MenuStyled
			className={`nav ${isPinned ? `is-pinned` : ``}`}
			items={items}
			mode='horizontal'
			onClick={handleClick}
			multiple={false}
			selectedKeys={[refHandlers.find(n => n.onScreen)?.key || `overview`]}
		/>
	);
};
